<template>
	<section class="section guide">
		<header class="section__header guide__header">
			<h2 class="section__title guide__header__title" v-html="t('page.betguide.inner.title')"></h2>
		</header>
		<div class="section__content">
			<slick class="guide__container"
				   :options="slickOptions"
				   ref="slick_guides"
					v-if="guides.length > 0">

				<article
                class="guide__item "
                :key="'small-guide_'+snakeCase(guide.name)"
                :class="'guide__item--'+snakeCase(guide.name)"
                v-for="(guide) in guides">
					<header class="guide__item__header" :data-count="guide.minhorse">
						{{guide.title}}
						<div class="guide__item__header__ico"></div>
					</header>
					<div class="guide__item__price">
						{{formatToMoney(guide.minstake)}}
					</div>
					<div class="guide__item__content" v-html="guide.teaser">

					</div>
					<!--<footer class="guide__item__footer">
						<a class="guide__item__link" href="#readmore">Lire la suite</a>
					</footer>-->
				</article><!-- /.guide__item -->
			</slick><!-- /.guide__container -->
		</div><!-- /.section__content -->
	</section><!-- /.section.guide -->
</template>
<script>
	//require('slick-carousel');
	import Slick from 'vue-slick';

	export default {
		name: 'Guide',
		components: { Slick },
		data() {
			return {
				slickOptions:{
					mobileFirst: true,
					slidesToShow: 1,
					swipeToSlide: true,
					responsive: [{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3
						}
					}, {
						breakpoint: 600,
						settings: {
							slidesToShow: 2
						}
					}]
				}
			}
		},
		computed:{
			guides(){
				return this.$store.state.once.betGuide.slice().sort((a, b)=>{

					return this.$store.getters.getTypePriorityByName(a.name) - this.$store.getters.getTypePriorityByName(b.name);
				});
			}
		},
		watch:{
			/*guides(val){
				if(val.length > 0){
					this.$nextTick(() => {
						this.$refs.slick_guides.reSlick();
					});
				}
			}*/
		},
		mounted() {
			this.$store.dispatch('getBetGuides');
			/*$('.guide__container').slick({
				mobileFirst: true,
				slidesToShow: 1,
				swipeToSlide: true,
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: 2
					}
				}]
			});*/
		},
		methods: {



		}
	}
</script>
